'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleCore = require('reactackle-core');

var _AccordionItem = require('./AccordionItem/AccordionItem');

var _AccordionItem2 = _interopRequireDefault(_AccordionItem);

var _AccordionStyled = require('./styles/AccordionStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('accordion', _theme2.default);
var propTypes = {
  /**
   * Speed of exit animation
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, _AccordionItem2.default.propTypes, {
    content: _propTypes2.default.node
  }))),

  /**
   * Define if Item has state itself
   */
  stateless: _propTypes2.default.bool,

  /**
   * Array of expanded Item's ids
   */
  expandedItemIds: _propTypes2.default.arrayOf(_propTypes2.default.string),

  /**
   * Expand all items at once
   */
  expandAll: _propTypes2.default.bool,

  /**
   * If true, only one item may be expanded at one time
   */
  single: _propTypes2.default.bool,

  /**
   * Function to be called on Item title click
   */
  onChange: _propTypes2.default.func
};
var defaultProps = {
  items: [],
  expandedItemIds: [],
  expandAll: false,
  single: false,
  stateless: false,
  onChange: _reactackleCore.noop
};

var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

    if (!props.stateless) {
      var expandedItemIds = void 0;
      if (props.expandAll) expandedItemIds = props.items.map(function (item) {
        return item.id;
      });else expandedItemIds = props.expandedItemIds;
      _this.state = {
        expandedItemIds: expandedItemIds
      };
    }

    _this._handleItemExpand = _this._handleItemExpand.bind(_this);
    return _this;
  }

  _createClass(Accordion, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var expandedItemIds = _ref.expandedItemIds;
      if (expandedItemIds !== this.props.expandedItemIds && !this.props.stateless) this.setState({
        expandedItemIds: expandedItemIds
      });
    }
  }, {
    key: '_getExpandedItemIds',
    value: function _getExpandedItemIds() {
      if (!this.props.stateless) return this.state.expandedItemIds;
      return this.props.expandedItemIds;
    }
  }, {
    key: '_toggleItemExpand',
    value: function _toggleItemExpand(itemId) {
      var expandedItemIds = this._getExpandedItemIds().slice();

      var idx = expandedItemIds.indexOf(itemId);
      if (expandedItemIds.length && expandedItemIds.includes(itemId)) expandedItemIds.splice(idx, 1);else if (this.props.single) expandedItemIds = [itemId];else expandedItemIds.push(itemId);
      return expandedItemIds;
    }
  }, {
    key: '_isExpanded',
    value: function _isExpanded(itemId) {
      if (!this.props.stateless) return this.state.expandedItemIds.includes(itemId);
      return this.props.expandedItemIds.includes(itemId);
    }
  }, {
    key: '_handleItemExpand',
    value: function _handleItemExpand(_ref2) {
      var id = _ref2.id;

      var newExpandedIds = this._toggleItemExpand(id);

      if (!this.props.stateless) {
        this.setState({
          expandedItemIds: newExpandedIds
        });
      }

      this.props.onChange({
        expandedItemIds: newExpandedIds
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.props.items && this.props.items.map(function (item, index) {
        var expanded = _this2._isExpanded(item.id);

        return _react2.default.createElement(_AccordionItem2.default, _extends({
          key: (0, _reactackleCore.getKey)(item, index),
          id: item.id,
          title: item.title,
          expanded: expanded,
          headerSlot: item.headerSlot,
          onToggleExpanded: _this2._handleItemExpand
        }, item), item.content);
      });
      return _react2.default.createElement(_AccordionStyled.AccordionStyled, {
        role: 'presentation'
      }, items, this.props.children);
    }
  }]);

  return Accordion;
}(_react.Component);

exports.default = Accordion;
Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
Accordion.displayName = 'Accordion';